import React from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const getMediaUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('/uploads/')) {
    return `${API_URL}${url}`;
  }
  return url;
};

const formatDuration = (seconds) => {
  if (!seconds) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const MediaList = ({ type, items, onRemove, disabled }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      {items.map((item, index) => (
        <div
          key={item.id || item.mediaId || index}
          className="flex items-center gap-3 p-2 bg-gray-50 rounded-lg"
        >
          {type === 'image' ? (
            <img
              src={getMediaUrl(item.url)}
              alt={item.originalFilename}
              className="w-16 h-16 object-cover rounded"
            />
          ) : (
            <div className="w-16 h-16 bg-gray-200 rounded flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
            </div>
          )}

          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium truncate">{item.originalFilename}</p>
            {type === 'audio' && item.durationSeconds && (
              <p className="text-xs text-gray-500">
                Duration: {formatDuration(item.durationSeconds)}
                {' '}(Cost: {Math.max(1, Math.ceil(item.durationSeconds / 30))})
              </p>
            )}
            {type === 'image' && (
              <p className="text-xs text-gray-500">Cost: 1</p>
            )}
          </div>

          {!disabled && (
            <button
              onClick={() => onRemove(index)}
              className="p-1 text-gray-400 hover:text-red-600 transition-colors"
              title="Remove"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
